import React from 'react';
import Typed from 'react-typed';

const WebTwo = () => {
    return (
        <div className="rwt-about-area rn-section-gap back-white">
            <div className="container">
                <div className="row row--30 align-items-center">
                <div className="col-lg-6">
                        <div className="thumbnail">
                            <img className="w-100" src="design-33.jpg" alt="About Images" />
                        </div>
                    </div>

                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                        <div className="content">
                            <div className="section-title">
                                <h2 className="title color-black">Usabilidad intuitiva  <br /> {" "}
                                    <span className="theme-gradient">
                                        Sabemos que necesitas
                                    </span>
                                </h2>
                                 <p>Manejo<strong> líneas gráficas actuales</strong>, basándose en reglas de usabilidad, combinamos la<strong> personalidad de tu proyecto</strong> con una forma correcta de proyectarlo, queremos que tus clientes vean lo que <strong>necesitas que vean</strong>, que tengan una buena experiencia y logremos la anhelada conversión.</p>
                                   <div className="read-more-btn mt--40">
                                     <a className="btn-default" href="https://kingart.com.co/world/tienda/" target="_blank"><span>¡Contactame!</span></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    

                    
                </div>
            </div>   
        </div>
    )
}

export default WebTwo;   
